<div class="app-shell">
  @if (!hideChrome()) {
  <krc-krc-header (openPropertyIntake)="intakeModal.open()" />
  }
  <main class="app-content">
    <router-outlet />
  </main>
  <!-- <krc-krc-footer /> -->
 @if (!hideChrome()) {
  <krc-krc-footer />
 }

  <krc-property-intake [(visible)]="intakeModal.visible" />
</div>
